module.exports = __webpack_public_path__ + "img/tr.a6e7c087.svg";